<template>
  <div>
    <AddCourse update @update="updateCourse = !updateCourse" :key="updateCourse" />
    <Toast title="بروزرسانی با موفقیت انجام شد" :showToast="showToast" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import AddCourse from '../../../components/mooc/courses/AddCourse.vue'
import Toast from '../../../components/common/Toast.vue'
export default {
  page: {
    title: 'ویرایش دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-edit-courses',
  data() {
    return {
      updateCourse: false,
      showToast: false,
    }
  },
  watch: {
    updateCourse() {
      this.updateToast()
    },
  },
  methods: {
    updateToast() {
      this.showToast = true
    },
  },
  components: {
    AddCourse,
    Toast,
  },
}
</script>
